import { SeriesRecord } from '@/components/Chart/types/chartData';
import getDecimalPlaces from '@/utils/getDecimalPlaces';

export const getFieldDecimalPlaces = (fieldValue: SeriesRecord[] | undefined[]): number =>
  fieldValue?.[0]?.[1] ? getDecimalPlaces(fieldValue[0][1]) : 0;
